module.exports = __webpack_public_path__ + "static/git-5e24c1f38e81d4ec7388a6c9b1919d3c.png";